import React from 'react';
import Timestamp from '../../components/Timestamp';
import Tooltip from '../../components/Tooltip';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const POST_FRAGMENT = gql(`
  fragment PostLastEdited_post on Post {
    version
    # eslint-disable-next-line slab-graphql/no-unused-fields
    content
    externalPost {
      id
    }
    updatedAt
  }
`);

const HISTORY_FRAGMENT = gql(`
  fragment PostLastEdited_lastHistory on SlimHistory {
    id
    insertedAt
    versionTo
    authors {
      id
      name
    }
  }
`);

interface PostLastEditedProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  lastHistory?: DocumentType<typeof HISTORY_FRAGMENT>;
  showTooltip?: boolean;
}

const PostLastEdited = ({
  showTooltip,
  post,
  lastHistory,
}: PostLastEditedProps) => {
  const { externalPost, version } = post;
  let { updatedAt } = post;

  if (version === 0) {
    return null;
  }

  if (externalPost) {
    return (
      <>
        Synced <Timestamp date={updatedAt} />
      </>
    );
  }
  let author;
  if (lastHistory && lastHistory.versionTo >= version) {
    updatedAt = lastHistory.insertedAt;
    if (lastHistory.authors.length > 0) {
      [author] = lastHistory.authors;
    }
  }

  return (
    <Tooltip
      placement="bottom"
      trigger="hover"
      tooltip={author && showTooltip && `Last edited by ${author.name}`}
    >
      Edited <Timestamp date={updatedAt} />
    </Tooltip>
  );
};

export default PostLastEdited;
